module.exports = __webpack_public_path__ + "img/part3-4.c5ba01bd.png";